<template>
  <modal :modal-key="'failed_purchase_operator'" :class-style="'modal--welcomeback modal--zero-balance'"
         @close="$emit('close')">
        <template slot="header">
          <h1>{{ getTranslations.home_modals_failed_purchase_operator_purchase_failed }}</h1>
          <img class="usericon" src="static/images/sad_face.svg" alt="">
        </template>
        <template slot="body">
          {{ getTranslations.home_modals_failed_purchase_operator_purchase_not_successful }}
        </template>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';


export default {
  name: 'failedPurchaseOperator',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/FailedPurchaseOperator.vue